/* eslint-disable */
import React from 'react'
import '../../lesFactor.css'
import {message} from 'antd'
import http from '../Interceptor/Interseptor'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import Loader from '../loaders/loader'
import SmallBasckets from './smallBasckets'
import BigBasckets from './bigBasckets'
import jMoment from 'moment-jalaali'
import './A4Print.css'

export default class A4Print extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      list: [],
      lesFactors: [],
      moreFactors: [],
      lesBtn: true,
      moreBtn: false,
      spliceDigit: 11,
      printDate: null
    }
  }
  componentDidMount() {
    if (this.props.location.search !== '') {
      let params = this.props.location.search + '&export=true'
      this.setState({
        loading: true
      })
      http
        .get(`${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_INDIVIDUAL}${params}`, {
          timeout: 100000
        })
        .then((response) => {
          // alert(JSON.stringify(response.data))
          if (response.data.error == null) {
            let res = response.data.object.result
            res.forEach((item) => {
              item.invoiceNum = item.invoice.invoiceNum.toString()
            })
            this.setState({
              list: res,
              loading: false,
              lesFactors: res.filter((item) => item.items.length <= this.state.spliceDigit),
              moreFactors: res.filter((item) => item.items.length > this.state.spliceDigit),
              printDate: jMoment().format('jYY/jMM/jDD HH:mm')
            })
          } else {
            this.setState({
              loading: false
            })
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          }
        })
        .catch(() => {
          this.setState({
            loading: false
          })
        })
    } else {
      message.error('امکان ساخت گزارش بدون ارسال فیلتر وجود ندارد')
    }
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;margin: 0 !important;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')
    style.type = 'text/css'
    style.media = 'print'
    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }
    head.appendChild(style)
    setTimeout(() => {
      window.print()
    }, 500)
  }
  sum = (item) => {
    let initialVal = 0
    let sum = item.reduce(function(acc, current) {
      return Number(acc) + Number(current.quantity)
    }, initialVal)
    if (sum !== null) {
      return parseFloat(sum.toFixed(2))
    } else {
      return ''
    }
  }
  render() {
    var totalAmount = 0
    var discountAmount = 0
    var payableAmount = 0

    function convertSefr() {
      totalAmount = 0
      discountAmount = 0
      payableAmount = 0
    }
    return (
      <div className="">
        <Loader show={this.state.loading} />
        <button className="printButton mb-2" onClick={this.exportPrint}>
          چاپ
        </button>
        <button
          className={this.state.lesBtn ? 'activeBtn mx-2' : 'deactiveBtn mx-2'}
          onClick={() => this.setState({lesBtn: true, moreBtn: false})}
        >
          فاکتورهای تا {this.state.spliceDigit - 1} قلم کالا
        </button>
        <button
          className={this.state.moreBtn ? 'activeBtn mx-2' : 'deactiveBtn mx-2'}
          onClick={() => this.setState({lesBtn: false, moreBtn: true})}
        >
          فاکتورهای بیش از {this.state.spliceDigit - 1} قلم کالا
        </button>
        {this.state.lesBtn && <SmallBasckets factors={this.state.lesFactors} printDate={this.state.printDate} />}
        {this.state.moreBtn && <BigBasckets factors={this.state.moreFactors} printDate={this.state.printDate} />}
      </div>
    )
  }
}
